<report-filter 
  showCostCenters='true'
  showFacilities='true'
  showShiftBlocks='true'
  showCensusTypes='true'
  showPeriodEndDateSelection='true'
  showPeriodEndDateSelection='true'
  defaultPayPeriodsBack=1
  showViews='true'
  [(views)]="views"
  [defaultView] = "defaultView"
  reportType='inpatient'
  [(defaultFilter)]="filters"
  (filterUpdated)="filterUpdated($event)">
</report-filter>

<smt-dailychurnratereport
  [filtersUpdated]='filterEventsSubject.asObservable()' 
  (dataUpdated)='dataUpdated($event)'
  [(reportFilters)]='filters'>
</smt-dailychurnratereport>

<report-export-button
[reportFilters]="filters"
[exportUrl]="'DailyChurn/GetInpatientChurnRateReportExportData'"
[fileName]="'Inpatient_ChurnRate_Report'"
[filtersUpdated]='filterEventsSubject.asObservable()'>
</report-export-button>

<table class='condensed' role='list'>
    <thead>
      <th><!-- empty row for the series names --></th>
      <th *ngFor='let item of data.xAxis'><div>{{item}}&nbsp;&nbsp;</div></th>
    </thead>
    <tr *ngFor='let dataSet of chartData'>
      <td>{{dataSet.name}}</td> 
      <td *ngFor='let item of dataSet.data'>{{formatCellValue(item, 0)}}</td>
    </tr>
  </table>
